import Breadcrumb from "../../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Container from "../../../components/admin/layouts/Container/Container";
import Header, { HeaderLeft, HeaderRight } from "../../../components/admin/layouts/Header/Header";
import PageWrapper from "../../../components/admin/layouts/PageWrapper/PageWrapper";
import Subheader, {
  SubheaderLeft,
  SubheaderRight,
  SubheaderSeparator,
} from "../../../components/admin/layouts/Subheader/Subheader";
import DefaultHeaderRightCommon from "../../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Card, { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../components/ui/Card";
import Label from "../../../components/ui/Label";
import Input from "../../../components/form/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import Icon from "../../../components/icon/Icon";
import themeConfig from "../../../config/theme.config";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import { GetPictureByContext, getContactById, savePicture, uploadBulkImg } from "../../../services/vizyBilityServices";
import Select from "../../../components/form/Select";
import { getContactStatuses, getSalutations, saveContact } from "../../../services/userContactService";
import { getContactTypes } from "../../../services/fetchContactTypes";
import { Google_map_Key } from "../../../api/url";
import { logoutFun } from "../../../utils/helper";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled

const AddUserContact = () => {
  const location = useLocation();
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const editUserInfo = location?.state?.editUserInfo;
  const [previewImage, setPreviewImage] = useState(null); // Image for modal preview
  const [images, setImages] = useState([]);
  const [defaultImg, setDefaultImg] = useState([]);
  const [addMachineLoader, setAddMachineLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [salutationsList, setSalutationsList] = useState([]);
  const [contactTypes, setContactTypes] = useState([]);
  const [contactStatuses, setContactStatuses] = useState([]);
  const [isCompanySelect, setIsCompanySelect] = useState({
    isSelected: false,
    CompanyId: null,
  });

  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData"))
    : null;

  const inputRef = useRef(null);
  const inputRef2 = useRef(null);

  const formik = useFormik({
    initialValues: {
      CompanyName: "",
      ContactName: "",
      ContactId: 0,
      SalutationId: "",
      FirstName: "",
      LastName: "",
      Title: "",
      Address1: "",
      Address2: "",
      OrganizationName: "",
      City: "",
      Province: "",
      PostalCode: "",
      Country: "",
      ContactTypeId: "",
      ContactStatusId: "",
      LocationId: "",
      ReportsToContactId: "",
      Comment: "",
      Email: "",
      HomePhone: "",
      Mobile: "",
      OfficePhone: "",
      Fax: "",
      LinkedIn: "",
      Birthday: "",
      Owner: "",
      ContactFrequencyValue: 0,
      ContactFrequencyTypeId: "",
    },
    validationSchema: Yup.object({
      SalutationId: Yup.string().required("Salutation is required"),
      FirstName: Yup.string().required("First Name is required"),
      LastName: Yup.string().required("Last Name is required"),
      Email: Yup.string().email("Invalid email").required("Email is required"),
      ContactTypeId: Yup.string().required("Type is required"),
      ContactStatusId: Yup.string().required("Status is required"),
    }),
    onSubmit: (values) => {
      handleSaveContact(values);
    },
  });

  useEffect(() => {
    if (editUserInfo?.ContactId) {
      getContactInfoById(editUserInfo?.ContactId);
      GetContactImgs(editUserInfo?.ContactId);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("StoreMachineData")) {
      const storedData = JSON.parse(localStorage.getItem("StoreMachineData"));
      const data = {
        ...storedData,
        images: JSON.parse(localStorage.getItem("StoreMachineImg")) || [], // Override the images property
      };
      formik.setValues(data); // Set the formik values
    }
  }, []);

  useEffect(() => {
    handleGetSalutations();
    handleGetContactType();
    handleGetContactStatuses();
  }, []);

  const GetContactImgs = (ContactId) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const query = `context=Contact&contextId=${ContactId}`;

    GetPictureByContext(query, header)
      .then((res) => {
        // setCompanyImg(res.data);

        let ImageList = [];
        res.data?.map((item, index) => {
          ImageList.push({
            ...item,
            New: false,
            preview: item?.url,
            sortCount: index,
          });
        });

        setDefaultImg(ImageList);
        setImages(ImageList);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const handleGetSalutations = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getSalutations(header)
      .then((res) => {
        setIsLoading(false);
        setSalutationsList(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const handleGetContactType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getContactTypes(header)
      .then((res) => {
        setContactTypes(res.data);
      })
      .catch((err) => {
        toast.error(err?.data);
      });
  };

  const handleGetContactStatuses = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getContactStatuses(header)
      .then((res) => {
        setContactStatuses(res.data);
      })
      .catch((err) => {
        toast.error(err?.data);
      });
  };

  const getContactInfoById = (userId) => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `contactId=${userId}`;
    getContactById(payload, header)
      .then((res) => {
        setIsLoading(false);
        formik.setValues({
          CompanyName: res.data?.CompanyName,
          ContactName: res.data?.ContactName,
          ContactId: res.data?.ContactId,
          SalutationId: res.data?.SalutationId || "",
          FirstName: res.data?.FirstName || "",
          LastName: res.data?.LastName || "",
          Title: res.data?.Title || "",
          Address1: res.data?.Address1 || "",
          Address2: res.data?.Address2 || "",
          OrganizationName: res.data?.OrganizationName || "",
          City: res.data?.City || "",
          Province: res.data?.Province || "",
          PostalCode: res.data?.PostalCode || "",
          Country: res.data?.Country || "",
          ContactTypeId: res.data?.ContactTypeId || "",
          ContactStatusId: res.data?.ContactStatusId || "",
          LocationId: res.data?.LocationId || "",
          ReportsToContactId: res.data?.ReportsToContactId || "",
          Comment: res.data?.Comment || "",
          Email: res.data?.Email || "",
          HomePhone: res.data?.HomePhone || "",
          // Bug fix: API returns Phone not Mobile/OfficePhone - add fallbacks
          Mobile: res.data?.Mobile || res.data?.MobilePhone || "",
          OfficePhone: res.data?.OfficePhone || res.data?.Phone || "",
          Fax: res.data?.Fax || "",
          LinkedIn: res.data?.LinkedIn || "",
          Birthday: res.data?.Birthday || "",
          Owner: res.data?.Owner || "",
          ContactFrequencyValue: res.data?.ContactFrequencyValue || 0,
          ContactFrequencyTypeId: res.data?.ContactFrequencyTypeId || "",
        });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  // Handle file selection
  const handleFiles = async (files) => {
    const newImages = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      New: true,
      sortCount: images?.length + 1,
      AddedToAdvertisement: true,
    }));
    setImages((prev) => [...prev, ...newImages]);
    formik.setFieldValue("images", [...images, ...newImages]);
    // Clear the input field value
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
    }
    if (inputRef2 && inputRef2.current) {
      inputRef2.current.value = "";
    }
  };
  // Handle drag-and-drop
  const handleDrop = (event) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  // Remove image
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    formik.setFieldValue("images", updatedImages);
  };

  // Open preview modal
  const openPreview = (image) => {
    setPreviewImage(image);
  };

  // Close preview modal
  const closePreview = () => {
    setPreviewImage(null);
  };

  const handlePlaceSelect = (place, formik) => {
    const addressComponents = place?.address_components || [];

    const getComponent = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));

      return component ? component.long_name : "";
    };
    formik.setFieldValue(
      "location",
      `${place?.formatted_address} ${getComponent(["sublocality", "neighborhood"])} ${getComponent([
        "locality",
        "administrative_area_level_2",
      ])} ${getComponent(["administrative_area_level_1"])} ${getComponent(["country"])}` || formik.values.address1
    );

    formik.setFieldValue("Address1", place?.formatted_address || formik.values.address1);
    formik.setFieldValue("Address2", getComponent(["sublocality", "neighborhood"]) || "");
    formik.setFieldValue("City", getComponent(["locality", "administrative_area_level_2"]));
    formik.setFieldValue("Province", getComponent(["administrative_area_level_1"]));
    formik.setFieldValue("Country", getComponent(["country"]));
    formik.setFieldValue("PostalCode", getComponent(["postal_code"]));
  };

  const handleSaveContact = (value) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = {
      ...value,
      CompanyId: azureUserInfo?.CompanyId,
    };

    if (editUserInfo?.ContactId) {
      payload = {
        ...payload,
        ContactId: editUserInfo.ContactId,
      };
    }
    saveContact(payload, header)
      .then(async (res) => {
        setAddMachineLoader(false);
        getContactInfoById(res.data.ContactId);
        await uploadImg(res.data);
        GetContactImgs(res.data.ContactId);
        if (editUserInfo?.ContactId) {
          toast.success("Contact edited successfully.");
        } else {
          toast.success("Contacts added successfully.");
        }
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const uploadImg = async (ContactInfo) => {
    try {
      const header = {
        authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
      };

      // Ensure `images` is available and not empty
      if (!images || images.length === 0) {
        toast.error("No images to upload!");
        return;
      }

      const uploadIMG = images.filter((item) => item.New);

      const uploadPromises = uploadIMG.map(async (item, index) => {
        const url = `pictureId=${ContactInfo?.ContactId}&directoryName=Dev`;
        const payload = new FormData();
        payload.append("file", item.file);

        try {
          // Upload image
          const uploadResponse = await uploadBulkImg(payload, header, url);
          let imgPayload = {
            Context: "Contact",
            ContextId: ContactInfo?.ContactId,
            url: uploadResponse.data.url,
            PictureUuid: uploadResponse.data.pictureUuid,
            PictureContentType: uploadResponse.data.pictureContentType,
            FileSizeInBytes: uploadResponse.data.file.Length,
            FileName: uploadResponse.data.file.FileName.substring(
              0,
              uploadResponse.data.file.FileName.lastIndexOf(".")
            ),
            FileFullName: uploadResponse.data.file.FileName,
            folderFetachParam: {
              Context: "Contact",
              ContextId: ContactInfo?.ContactId, // Replace Asset ID
            },
          };

          if (index == 0) {
            imgPayload = {
              ...imgPayload,
              Main: true, // this flag working for main img set in asset for 1st img
            };
          }
          // Save the picture
          const saveResponse = await savePicture(imgPayload, header);
          return { ...saveResponse?.data, SelectedAdvertisement: item?.AddedToAdvertisement || false };
        } catch (uploadErr) {
          console.error("Error uploading image:", uploadErr);
          toast.error(uploadErr?.data || "Image upload failed!");
          throw uploadErr; // Propagate error for outer handling
        }
      });

      // Wait for all uploads to finish
      const ImgList = await Promise.all(uploadPromises);

      const ContextIds = ImgList?.filter((item) => item?.SelectedAdvertisement)?.map((item) => item.PictureId);
      const ContextExistIds = images?.filter((item) => item?.AddedToAdvertisement)?.map((item) => item.PictureId);
      const mergedArray = [
        ...new Set([...ContextIds, ...ContextExistIds].filter((id) => id !== null && id !== undefined)),
      ];
    } catch (err) {
      console.error("Error in uploadImg:", err);
      toast.error("Failed to upload images!");
      setAddMachineLoader(false);
    } finally {
    }
  };

  return (
    <>
      <Header>
        <HeaderLeft>
          <Breadcrumb path="Paving Market / User Contacts Info" currentPage="User Contacts" />
        </HeaderLeft>
        <HeaderRight>
          <DefaultHeaderRightCommon />
        </HeaderRight>
      </Header>

      <PageWrapper name="User Contacts Info">
        <Subheader>
          <SubheaderLeft>
            <Link to={`/admin/user`}>
              <Button icon="HeroArrowLeft" className="!px-0">
                Back to List
              </Button>
            </Link>
            <SubheaderSeparator />
            {editUserInfo?.ContactId ? "Edit Contacts" : "Add Contacts"}
          </SubheaderLeft>
          <SubheaderRight>
            <Button variant="solid" onClick={() => formik.submitForm()}>
              Save
            </Button>
          </SubheaderRight>
        </Subheader>

        <Container>
          {isLoading || addMachineLoader ? (
            <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0  right-0">
              <span class="loader"></span>
            </div>
          ) : null}
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <h1 className="my-4 font-bold uppercase">LIST YOUR Contacts</h1>
            </div>
            <div className="col-span-12 lg:col-span-9">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                  <Card>
                    <CardHeader>
                      <CardHeaderChild>
                        <CardTitle>General Info</CardTitle>
                      </CardHeaderChild>
                    </CardHeader>
                    <CardBody>
                      <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-4">
                          <Label htmlFor="id">Salutation</Label>
                          <Select
                            name="SalutationId"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.SalutationId}
                            placeholder="Select role"
                          >
                            <option value="" disabled>
                              <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Salutation</div>
                            </option>
                            {salutationsList.map((item) => {
                              return (
                                <option
                                  className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                  value={item.SalutationId}
                                >
                                  <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.SalutationName}</div>
                                </option>
                              );
                            })}
                          </Select>
                          {formik.touched.SalutationId && formik.errors.SalutationId ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.SalutationId}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">First Name</Label>
                          <Input
                            type="text"
                            name="FirstName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.FirstName}
                            placeholder="Enter here"
                          />
                          {formik.touched.FirstName && formik.errors.FirstName ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.FirstName}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Last Name</Label>
                          <Input
                            type="text"
                            name="LastName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.LastName}
                            placeholder="Enter here"
                          />
                          {formik.touched.LastName && formik.errors.LastName ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.LastName}</p>
                          ) : null}
                        </div>

                        <div className="col-span-4">
                          <Label htmlFor="id">Email</Label>
                          <Input
                            type="email"
                            name="Email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Email}
                            placeholder="Enter here"
                          />
                          {formik.touched.Email && formik.errors.Email ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Email}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Type</Label>
                          <Select
                            name="ContactTypeId"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.ContactTypeId}
                            placeholder="Select role"
                          >
                            <option value="" disabled>
                              <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Salutation</div>
                            </option>
                            {contactTypes.map((item) => {
                              return (
                                <option
                                  className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                  value={item.ContactTypeId}
                                >
                                  <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.ContactTypeName}</div>
                                </option>
                              );
                            })}
                          </Select>
                          {formik.touched.ContactTypeId && formik.errors.ContactTypeId ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.ContactTypeId}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Status</Label>
                          <Select
                            name="ContactStatusId"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.ContactStatusId}
                            placeholder="Select role"
                          >
                            <option value="" disabled>
                              <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Salutation</div>
                            </option>
                            {contactStatuses.map((item) => {
                              return (
                                <option
                                  className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                  value={item.ContactStatusId}
                                >
                                  <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.ContactStatusName}</div>
                                </option>
                              );
                            })}
                          </Select>
                          {formik.touched.ContactStatusId && formik.errors.ContactStatusId ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.ContactStatusId}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Mobile Phone</Label>
                          <Input
                            type="tel"
                            name="Mobile"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Mobile}
                            placeholder="Enter here"
                          />
                          {formik.touched.Mobile && formik.errors.Mobile ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Mobile}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Office Phone</Label>
                          <Input
                            type="tel"
                            name="OfficePhone"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.OfficePhone}
                            placeholder="Enter here"
                          />
                          {formik.touched.OfficePhone && formik.errors.OfficePhone ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.OfficePhone}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Home Phone</Label>
                          <Input
                            type="tel"
                            name="HomePhone"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.HomePhone}
                            placeholder="Enter here"
                          />
                          {formik.touched.HomePhone && formik.errors.HomePhone ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.HomePhone}</p>
                          ) : null}
                        </div>
                        <div className="col-span-12">
                          <Label htmlFor="id">Title</Label>
                          <Input
                            type="text"
                            name="Title"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Title}
                            placeholder="Enter here"
                          />
                          {formik.touched.Title && formik.errors.Title ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Title}</p>
                          ) : null}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <div className="col-span-12">
                  <Card>
                    <CardHeader>
                      <CardHeaderChild>
                        <CardTitle>Address</CardTitle>
                      </CardHeaderChild>
                    </CardHeader>
                    <CardBody>
                      <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-6">
                          <Label htmlFor="id">Address 1</Label>

                          <GooglePlacesAutocomplete
                            apiKey={Google_map_Key}
                            onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                            onChange={(e) => {
                              formik.setValues({
                                ...formik.values,
                                Address1: e.target.value,
                              });
                            }}
                            options={{
                              types: ["address"],
                            }}
                            value={formik.values.Address1}
                            disabled={isCompanySelect.isSelected}
                            className={`w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg`}
                          />
                          {formik.touched.Address1 && formik.errors.Address1 ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Address1}</p>
                          ) : null}
                        </div>

                        <div className="col-span-6">
                          <Label htmlFor="id">Address2</Label>
                          <Input
                            type="text"
                            name="Address2"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Address2}
                            placeholder="Enter here"
                          />
                          {formik.touched.Address2 && formik.errors.Address2 ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Address2}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">City</Label>
                          <Input
                            type="text"
                            name="City"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.City}
                            placeholder="Enter here"
                          />
                          {formik.touched.City && formik.errors.City ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.City}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">State/Province</Label>
                          <Input
                            type="text"
                            name="Province"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Province}
                            placeholder="Enter here"
                          />
                          {formik.touched.Province && formik.errors.Province ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Province}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Zip/Postal Code</Label>
                          <Input
                            type="text"
                            name="PostalCode"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.PostalCode}
                            placeholder="Enter here"
                          />
                          {formik.touched.PostalCode && formik.errors.PostalCode ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.PostalCode}</p>
                          ) : null}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-span-12">
                  <Card>
                    <CardHeader>
                      <CardHeaderChild>
                        <CardTitle>Image</CardTitle>
                      </CardHeaderChild>
                    </CardHeader>
                    <CardBody>
                      <div
                        className={classNames(
                          "mt-2",
                          "flex justify-center",
                          "rounded-lg",
                          "border border-dashed border-zinc-500/25",
                          "px-6 py-10",
                          "dark:border-zinc-500/50"
                        )}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}
                      >
                        <div className="text-center">
                          <Icon
                            icon="HeroPhoto"
                            className="mx-auto h-12 w-12"
                            color={themeConfig.themeColor}
                            colorIntensity={themeConfig.themeColorShade}
                          />
                          <div className="mt-4 flex text-sm leading-6 text-gray-500">
                            <label
                              htmlFor="file-upload"
                              className={classNames(
                                "relative",
                                "cursor-pointer",
                                "rounded-md",
                                "font-semibold",
                                "text-blue-500",
                                "focus-within:outline-none",
                                "focus-within:ring-2 focus-within:ring-blue-600 focus-within:ring-offset-2 focus-within:ring-offset-transparent",
                                "hover:text-blue-600",
                                themeConfig.transition
                              )}
                            >
                              <span>Upload a file</span>
                              <input
                                id="file-upload"
                                name="file-upload"
                                type="file"
                                className="sr-only"
                                ref={inputRef2}
                                onChange={(e) => handleFiles(e.target.files)}
                              />
                            </label>
                            <span className="pl-1">or drag and drop</span>
                          </div>
                          <p className="text-xs leading-5 text-gray-500">PNG, JPG</p>
                        </div>
                        <input
                          type="file"
                          id="fileInput"
                          className="hidden"
                          accept="image/*"
                          ref={inputRef}
                          onChange={(e) => handleFiles(e.target.files)}
                        />
                      </div>
                      {formik.touched.images && formik.errors.images ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.images}</p>
                      ) : null}
                    </CardBody>
                  </Card>
                </div>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-3">
              <Card className="top-scroll-offset sticky">
                <CardHeader>
                  <CardHeaderChild>
                    <CardTitle>Image Preview</CardTitle>
                  </CardHeaderChild>
                  <CardHeaderChild>
                    <Button icon="HeroArrowTopRightOnSquare" />
                  </CardHeaderChild>
                </CardHeader>
                <CardBody>
                  <div className="flex flex-col gap-4 max-h-[500px] overflow-auto">
                    {" "}
                    {images?.length <= 0 ? (
                      <div className="flex w-full items-center justify-center text-center h-[300px]">
                        <CardTitle>No Image Available</CardTitle>
                      </div>
                    ) : (
                      <div className="mt-[20px] grid-cols-1">
                        {images.map((image, index) => (
                          <div key={index} className="relative group border rounded-lg overflow-hidden my-[10px]">
                            {/* Image */}
                            <img
                              src={image.preview}
                              alt={`Preview ${index}`}
                              className="w-full h-[170px] object-cover"
                            />

                            {/* Hover Preview */}
                            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                              <button
                                className="text-white text-sm bg-gray-700 py-1 px-3 rounded hover:bg-gray-800"
                                onClick={() => openPreview(image.preview)}
                              >
                                Preview
                              </button>
                            </div>

                            {/* Remove Button */}
                            {image?.New && (
                              <button
                                className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1 text-xs hover:bg-red-700 w-[20px] h-[20px]"
                                onClick={() => removeImage(index)}
                              >
                                ✕
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
          {previewImage && (
            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
              <div className="relative bg-zinc-100 dark:bg-zinc-800 p-4 rounded-lg max-w-[90%] max-h-[90%]">
                <button
                  className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700  w-[30px] h-[30px] cursor-pointer flex items-center justify-center"
                  onClick={closePreview}
                >
                  ✕
                </button>
                <img src={previewImage} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
              </div>
            </div>
          )}
        </Container>
      </PageWrapper>
    </>
  );
};
export default AddUserContact;
